import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export function StatusChart({ data = {} }) {
  // Transformar datos para el gráfico
  const chartData = [
    { name: 'Pendientes', value: data.pending || 0, color: '#f97316' },
    { name: 'Aprobadas', value: data.approved || 0, color: '#10b981' },
    { name: 'Cumplidas', value: data.fulfilled || 0, color: '#3b82f6' },
    { name: 'Rechazadas', value: data.rejected || 0, color: '#ef4444' },
    { name: 'Canceladas', value: data.cancelled || 0, color: '#6b7280' }
  ].filter(item => item.value > 0); // Solo mostrar estados con valores

  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-400">
        No hay datos para mostrar
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            fontSize: '12px'
          }}
        />
        <Legend
          wrapperStyle={{ fontSize: '12px' }}
          iconType="circle"
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
